/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { IonPopover, ModalController } from '@ionic/angular/standalone'
import { UserReport } from '../../../src/commons/models/user-report.model'
import { InviteUserComponent } from '../../../src/app/administration/invite-user/invite-user.component'
import { ReportClaims, UserClaims } from '../enums/user-claims.enum'
import { CacheService } from '../services/business/cache.service'
import { PlatformService } from '../services/business/platform.service'
import { ClaimsService } from '../services/business/claims.service'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { UserDto, AppUserClaims } from '../../../src/security/models'
import { AuthWrapperService } from '../../../src/security/models/services/auth'

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent implements OnInit {
  @Input() contentId: string
  @Output() reload: EventEmitter<void> = new EventEmitter<void>()

  private orgId: number
  private user: UserDto
  public isAdminOpen = false
  public isAccountsOpen = false
  public isReportsOpen = false
  private _arrowDown = 'caret-down-outline'
  private _arrowRight = 'caret-forward-outline'
  private _chevronRight = 'chevron-forward-outline'
  private _chevronDown = 'chevron-down-outline'
  loggedUserClaims: AppUserClaims[]
  canViewAdmin = false
  canInviteUsers = false
  canViewUsers = false
  canViewOrgs = false
  canUpdateProgramCardArt = false
  canViewNegativeBalanceSummary = false
  canViewAccounts = false
  canSearchAccount = false
  canViewReports = false
  canViewPrograms = false
  canDownloadReportFiles = false
  @ViewChild('adminPopover') adminPopover: IonPopover
  @ViewChild('accountsPopover') accountsPopover: IonPopover
  @ViewChild('reportsPopover') reportsPopover: IonPopover
  userReports: UserReport[]

  public get adminIcon(): string {
    return this.isAdminOpen ? this._arrowDown : this._arrowRight
  }

  public get accountsIcon(): string {
    return this.isAccountsOpen ? this._arrowDown : this._arrowRight
  }

  public get reportsIcon(): string {
    return this.isReportsOpen ? this._arrowDown : this._arrowRight
  }

  public get adminMobileIcon(): string {
    return this.isAdminOpen ? this._chevronDown : this._chevronRight
  }

  public get accountsMobileIcon(): string {
    return this.isAccountsOpen ? this._chevronDown : this._chevronRight
  }

  public get reportsMobileIcon(): string {
    return this.isReportsOpen ? this._chevronDown : this._chevronRight
  }

  constructor(
    private authWrapperService: AuthWrapperService,
    private cacheService: CacheService,
    private claimsService: ClaimsService,
    public modalController: ModalController,
    public platform: PlatformService,
    private router: Router,
    private readonly titleService: Title,
    activatedRoute: ActivatedRoute
  ) {
    this.cacheService.internalUserOrgChanged.subscribe(async () => {
      this.cacheService.resetUserReports()
      void await this.showHideOptions()
      if (activatedRoute &&
        activatedRoute.routeConfig &&
        activatedRoute.routeConfig.path &&
        activatedRoute.routeConfig.path == 'users' &&
        !this.canViewUsers) {

        setTimeout(() => {
          void this.router.navigate(['/home'])
        }, 100)
      }
    })
  }

  public async ngOnInit(): Promise<void> {
    this.user = await this.cacheService.getUserInfo()
    this.orgId = this.user.orgRId
    this.loggedUserClaims = await this.cacheService.getUserClaims()
    void this.showHideOptions()
  }

  logout(): void {
    void this.cacheService.clearCache()
    void this.authWrapperService.logOut()
  }

  public toggleAdminSubMenu(showMenu = false, event: MouseEvent = null): void {
    if (this.platform.isDesktop()) {
      this.isAdminOpen = showMenu
      if (event) {
        this.openPopover(this.adminPopover, event)
      }
      if (!showMenu) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.adminPopover.dismiss()
      }
    } else {
      this.isAdminOpen = !this.isAdminOpen
    }
  }

  public toggleAccountsSubMenu(showMenu = false, event: MouseEvent = null): void {
    if (this.platform.isDesktop()) {
      this.isAccountsOpen = showMenu
      if (event) {
        this.openPopover(this.accountsPopover, event)
      }
      if (!showMenu) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.accountsPopover?.dismiss()
      }
    } else {
      this.isAccountsOpen = !this.isAccountsOpen
    }
  }

  public toggleReportsSubMenu(showMenu = false, event: MouseEvent = null): void {
    if (this.platform.isDesktop()) {
      this.isReportsOpen = showMenu
      if (event) {
        this.openPopover(this.reportsPopover, event)
      }
      if (!showMenu) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.reportsPopover.dismiss()
      }
    } else {
      this.isReportsOpen = !this.isReportsOpen
    }
  }

  public async showHideOptions(): Promise<void> {

    //administration
    void await this.ProcessAdministrationMenu()
    //end adminitration

    //accounts
    this.canViewAccounts =
      this.loggedUserClaims &&
      this.loggedUserClaims.find(
        (claim) => claim.key === UserClaims.AccountSearch) != null

    this.canSearchAccount =
      this.loggedUserClaims && this.loggedUserClaims.find((claim) => claim.key === UserClaims.AccountSearch) != null
    this.canViewReports = this.loggedUserClaims && (await this.claimsService.hasSomeReportClaim())
    //end accounts

    //reports
    this.userReports = (await this.cacheService.getUserReports()).filter((q) =>
      ReportClaims.some((x) => x == q.claimKey)
    )

    this.canViewPrograms =
      this.loggedUserClaims && this.loggedUserClaims.find((claim) => claim.key === UserClaims.Programs) != null
    this.canDownloadReportFiles = this.loggedUserClaims && (await this.claimsService.canDownloadReportFiles())
    //end reports
  }

  private openPopover(popover: IonPopover, event: MouseEvent): void {
    const rect: DOMRect = (event.target as HTMLElement).getBoundingClientRect()

    const newEvent = new MouseEvent('newMouseEvent', {
      ...event,

      clientX: rect.left,

      clientY: rect.top + rect.height,
    })
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    popover.present(newEvent)
  }

  public async showInviteUser(): Promise<void> {
    //hiding the menu
    this.toggleAdminSubMenu(false)

    //showing the popup
    const modal = await this.modalController.create({
      component: InviteUserComponent,
      backdropDismiss: false,
      cssClass: this.platform.isDesktop() ? 'user-details-modal' : '',
      componentProps: {
        orgId: this.orgId,
        callerTitle: this.titleService.getTitle()
      },
    })
    void modal.onDidDismiss().then(() => {
      if (this.reload) this.reload.emit()
    })
    return modal.present()
  }

  private async ProcessAdministrationMenu(): Promise<void> {
    this.canViewNegativeBalanceSummary =
      this.loggedUserClaims &&
      this.loggedUserClaims.find((claim) => claim.key === UserClaims.NegativeBalanceSummaryViewer) != null

    this.canViewAdmin =
      this.loggedUserClaims &&
      (
        (
          this.loggedUserClaims.find(
            (claim) => claim.key === UserClaims.ViewUser || claim.key === UserClaims.InviteNewUser
          ) != null && !(await this.cacheService.isInternalOrg())
        ) ||
        (
          this.loggedUserClaims.find(
            (claim) => claim.key === UserClaims.ViewInternalUser || claim.key === UserClaims.InviteInternalUser
          ) != null &&
          (await this.cacheService.isInternalOrg())
        ) ||
        (
          this.loggedUserClaims.find(
            (claim) => claim.key === UserClaims.ViewOrg
          ) != null &&
          (await this.cacheService.isInternalOrg())
        ) ||
        this.canViewNegativeBalanceSummary)

    this.canInviteUsers =
      this.loggedUserClaims &&
      (
        (
          this.loggedUserClaims.find((claim) => claim.key === UserClaims.InviteNewUser) != null &&
          !(await this.cacheService.isInternalOrg())
        ) ||
        (
          this.loggedUserClaims.find((claim) => claim.key === UserClaims.InviteInternalUser) != null &&
          (await this.cacheService.isInternalOrg())
        )
      )

    this.canViewUsers =
      this.loggedUserClaims &&
      (
        (
          this.loggedUserClaims.find((claim) => claim.key === UserClaims.ViewUser) != null &&
          !(await this.cacheService.isInternalOrg())
        ) ||
        (
          this.loggedUserClaims.find((claim) => claim.key === UserClaims.ViewInternalUser) != null &&
          (await this.cacheService.isInternalOrg())
        )
      )

    this.canViewOrgs =
      this.loggedUserClaims &&
      (
        (
          this.loggedUserClaims.find((claim) => claim.key === UserClaims.ViewOrg || claim.key === UserClaims.AddOrg || claim.key === UserClaims.EditOrg) != null &&
          (await this.cacheService.isInternalOrg())
        )
      )

    this.canUpdateProgramCardArt =
      this.loggedUserClaims &&
      (
        (
          this.loggedUserClaims.find((claim) => claim.key === UserClaims.UpdateCardArt) != null &&
          (await this.cacheService.isInternalOrg())
        )
      )
  }
}
